import { useStorePwa } from '../../hooks/useStorePwa.js';

/**
 * Regista manifest, meta tags e service worker da loja (sem UI).
 * @param {{
 *   slug: string,
 *   tenant?: { nome?: string | null, logo_url?: string | null, theme_json?: unknown } | null,
 * }} props
 */
export function StorePwaBootstrap({ slug, tenant }) {
  useStorePwa({ slug, tenant });
  return null;
}
